/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Steuerarten } from "../../Shared/Belege/Queries/Steuerart";
import i18n from "./../Internationalisierung/i18n";
import useT, { UseTranslationOptions } from "./Hooks/useTranslation";

export const useTranslation = (options?: UseTranslationOptions) => useT("i18nBasis", options);
export const fixedT = i18n.getFixedT(null, "i18nBasis");

export const translationKeys = {
    appSnackbar: {
        schliessen: "appSnackbar.schliessen",
        oeffnen: "appSnackbar.oeffnen",
    },
    appSnackbarModel: {
        dataNotFound: "appSnackbarModel.dataNotFound",
        internalError: "appSnackbarModel.internalError",
        notAuthorized: "appSnackbarModel.notAuthorized",
        default: "appSnackbarModel.default",
    },
    appSnackbarItemFactory: {
        erfolgreich: "appSnackbarItemFactory.erfolgreich",
        pdfError: "appSnackbarItemFactory.pdfError",
    },
    appMenu: {
        exporte: "appMenu.exporte",
        exportvorlagen: "appMenu.exportvorlagen",
        importe: "appMenu.importe",
        veranstaltungen: "appMenu.veranstaltungen",
        kategorien: "appMenu.kategorien",
        belege: "appMenu.belege",
        fibuExporte: "appMenu.fibuExporte",
        fibuExportEinstellungen: "appMenu.fibuExportEinstellungen",
        rabattcodes: "appMenu.rabattcodes",
        auswertungen: "appMenu.auswertungen",
        buchungsportal: "appMenu.buchungsportal",
        einstellungen: "appMenu.einstellungen",
        grundeinstellungen: "appMenu.grundeinstellungen",
        grundeinstellungenVerlassen: "appMenu.grundeinstellungenVerlassen",
        mandant: "appMenu.mandant",
        firmendaten: "appMenu.firmendaten",
        supporteinstellungen: "appMenu.supporteinstellungen",
        supporteinstellungenVerlassen: "appMenu.supporteinstellungenVerlassen",
        support: "appMenu.support",
        supportmandanten: "appMenu.supportmandanten",
        nummernkreise: "appMenu.nummernkreise",
        reportdesigner: "appMenu.reportdesigner",
        eMails: "appMenu.eMails",
        eMailprofile: "appMenu.eMailprofile",
        dokumente: "appMenu.dokumente",
        dokumentvorlagen: "appMenu.dokumentvorlagen",
        finanzeinstellungen: "appMenu.finanzeinstellungen",
        kontoAdresse: "appMenu.kontoAdresse",
        branding: "appMenu.branding",
        nutzende: "appMenu.nutzende",
        integration: "appMenu.integration",
        teams: "appMenu.teams",
        zoom: "appMenu.zoom",
        stripe: "appMenu.stripe",
        teilnahmen: "appMenu.teilnahmen",
        dozierende: "appMenu.dozierende",
        stornobedingungen: "appMenu.stornobedingungen",
        mitteilungen: "appMenu.mitteilungen",
        adressen: "appMenu.adressen",
        ressourcenplan: "appMenu.ressourcenplan",
        api: "appMenu.api",
        frageboegen: "appMenu.frageboegen",
        paypal: "appMenu.paypal",
        definitionen: "appMenu.definitionen",
        mandantBelege: "appMenu.mandantBelege",
        programmierschnittstelle: "appMenu.programmierschnittstelle",
        dokumentation: "appMenu.dokumentation",
        bestellungen: "appMenu.bestellungen",
        kooperationspartner: "appMenu.kooperationspartner",
        veranstaltungsreihen: "appMenu.veranstaltungsreihen",
        adresskategorien: "appMenu.adresskategorien",
        artikel: "appMenu.artikel",
        bestellteArtikel: "appMenu.bestellteArtikel",
        veranstaltungseinstellungen: "appMenu.veranstaltungseinstellungen",
        artikeleinstellungen: "appMenu.artikeleinstellungen",
        belegdruck: "appMenu.belegdruck",
        preise: "appMenu.preise",
        zusatzfelder: "appMenu.zusatzfelder",
        preisstamm: "appMenu.preisstamm",
        darstellung: "appMenu.darstellung",
        anpassungenFuerListenansichten: "appMenu.anpassungenFuerListenansichten",
        zertifikate: "appMenu.zertifikate",
        ticketscanner: "appMenu.ticketscanner",
        ressourcen: "appMenu.ressourcen",
        ressourcenkategorien: "appMenu.ressourcenkategorien",
        ressourcenEinstellungen: "appMenu.ressourcenEinstellungen",
        postausgang: "appMenu.postausgang",
        eMailTexte: "appMenu.eMailTexte",
        belegungen: "appMenu.belegungen",
        mahlzeiten: "appMenu.mahlzeiten",
        verpflegungsarten: "appMenu.verpflegungsarten",
        aushang: "appMenu.aushang",
        zahlungen: "appMenu.zahlungen",
        eMailEinstellungen: "appMenu.eMailEinstellungen",
        mitarbeiter: "appMenu.mitarbeiter",
        mitarbeiterRollen: "appMenu.mitarbeiterRollen",
    },
    appSnackbarTemplate: {
        neuAnmelden: "appSnackbarTemplate.neuAnmelden",
        neuLaden: "appSnackbarTemplate.neuLaden",
        zurHauptseite: "appSnackbarTemplate.zurHauptseite",
    },
    cloudApolloClientRetryLink: {
        serverNotResponding: "cloudApolloClientRetryLink.serverNotResponding",
    },
    cloudApolloClientProvider: {
        unauthorized: "cloudApolloClientProvider.unauthorized",
        keineRechte: "cloudApolloClientProvider.keineRechte"
    },
    cloudBrowserRouter: {
        nichtGespeicherteAenderungen: "cloudBrowserRouter.nichtGespeicherteAenderungen",
        moechtenSieDieAenderungenVerwerfen: "cloudBrowserRouter.moechtenSieDieAenderungenVerwerfen",
        speichern: "cloudBrowserRouter.speichern",
        verwerfen: "cloudBrowserRouter.verwerfen",
    },
    appCoffeeMug: {
        alt: "appCoffeeMug.alt",
    },
    commandBarSearchInput: {
        suchbegriffEingeben: "commandBarSearchInput.suchbegriffEingeben",
    },
    viewModel: {
        showCoffeeMugText: "viewModel.showCoffeeMugText",
    },
    yesNoDialog: {
        ja: "yesNoDialog.ja",
        nein: "yesNoDialog.nein",
    },
    cloudApolloErrorHandler: {
        unknownSource: "cloudApolloErrorHandler.unknownSource",
        unknownError: "cloudApolloErrorHandler.unknownError",
        networkError: "cloudApolloErrorHandler.networkError",
    },
    pflichtangabe: {
        pflichtangabe: "pflichtangabe.pflichtangabe",
    },
    loadMoreTableRow: {
        mehrLaden: "loadMoreTableRow.mehrLaden",
    },
    fileUploadBase: {
        falscheDateiendung: "fileUploadBase.falscheDateiendung",
        erlaubteDateiendungen: "fileUploadBase.erlaubteDateiendungen",
        zuKleineDatei: "fileUploadBase.zuKleineDatei",
        zuGrosseDatei: "fileUploadBase.zuGrosseDatei",
        maximaleDateigroesse: "fileUploadBase.maximaleDateigroesse",
        uploadButton: "fileUploadBase.uploadButtonText",
        uploaded: "fileUploadBase.uploadedText",
        uploadFehler: "fileUploadBase.uploadFehlerText",
        bereitZumUpload: "fileUploadBase.bereitZumUpload",
        dateiauswahl: "fileUploadBase.dateiauswahl",
        dateiauswahlPlural: "fileUploadBase.dateiauswahlPlural",
        zuVieleDateienFehler: "fileUploadBase.zuVieleDateienFehler"
    },
    dateTimeInput: {
        ok: "dateTimeInput.ok",
        abbrechen: "dateTimeInput.abbrechen",
    },
    dateInput: {
        ok: "dateInput.ok",
        abbrechen: "dateInput.abbrechen",
    },
    timeInput: {
        ok: "timeInput.ok",
        abbrechen: "timeInput.abbrechen",
    },
    steuerart: {
        netto: "steuerart.netto",
        brutto: "steuerart.brutto",
        umsatzsteuerbefreit: "steuerart.umsatzsteuerbefreit",
    },
    belegpositionTableHeader: {
        menge: "belegpositionTableHeader.menge",
        preis: "belegpositionTableHeader.preis",
        gesamtbetrag: "belegpositionTableHeader.gesamtbetrag",
        steuersatz: "belegpositionTableHeader.steuersatz",
    },
    belegpositionenTable: {
        gesamtNetto: "belegpositionenTable.gesamtNetto",
        gesamtBrutto: "belegpositionenTable.gesamtBrutto",
        gesamt: "belegpositionenTable.gesamt",
    },
    appAboutDialog: {
        caption: "appAboutDialog.caption",
        copyright: "appAboutDialog.copyright",
        version: "appAboutDialog.version",
        instanz: "appAboutDialog.instanz",
        ok: "appAboutDialog.ok",
        loading: "appAboutDialog.loading",
        licenseInformation: "appAboutDialog.licenseInformation",
    },
    lanFooter: {
        agb: "lanFooter.agb",
        datenschutz: "lanFooter.datenschutz",
        homepage: "lanFooter.homepage",
        impressum: "lanFooter.impressum"
    },
    autoComplete: {
        leeren: "autoComplete.leeren",
        schliessen: "autoComplete.schliessen",
        laden: "autoComplete.laden",
        keineOptionen: "autoComplete.keineOptionen",
        oeffnen: "autoComplete.oeffnen"
    },
    stripeCardElement: {
        nummer: "stripeCardElement.nummer",
        nummerPlaceholder: "stripeCardElement.nummerPlaceholder",
        pruefziffer: "stripeCardElement.pruefziffer",
        pruefzifferPlaceholder: "stripeCardElement.pruefzifferPlaceholder",
        gueltigBis: "stripeCardElement.gueltigBis",
        gueltigBisPlaceholder: "stripeCardElement.gueltigBisPlaceholder"
    },
    stripePaymentElement: {
        nummer: "stripePaymentElement.nummer",
        nummerPlaceholder: "stripePaymentElement.nummerPlaceholder",
        pruefziffer: "stripePaymentElement.pruefziffer",
        pruefzifferPlaceholder: "stripePaymentElement.pruefzifferPlaceholder",
        gueltigBis: "stripePaymentElement.gueltigBis",
        gueltigBisPlaceholder: "stripePaymentElement.gueltigBisPlaceholder",
        vollstaendigerName: "stripePaymentElement.vollstaendigerName",
        vollstaendigerNamePlaceholder: "stripePaymentElement.vollstaendigerNamePlaceholder",
        land: "stripePaymentElement.land",
        hinweisWeiterleitung: "stripePaymentElement.hinweisWeiterleitung",
        mandat: "stripePaymentElement.mandat",
        iban: "stripePaymentElement.iban",
        hinweisUeberweisung: "stripePaymentElement.hinweisUeberweisung",
    },
    country: {
        germany: "country.germany",
        austria: "country.austria",
        belgium: "country.belgium",
        spain: "country.spain",
        italy: "country.italy",
        netherlands: "country.netherlands",
    },
    externalCaptionLink: {
        buttonTitle: "externalCaptionLink.buttonTitle",
        meldung: "externalCaptionLink.meldung",
    },
    useExecute: {
        meldung: "useExecute.meldung"
    },
    errorView: {
        title: "errorView.title",
        subtitle: "errorView.subtitle",
        action: "errorView.action",
    },
    appZahlungsmethodeSetzenDialog: {
        title: "appZahlungsmethodeSetzenDialog.title",
        schliessen: "appZahlungsmethodeSetzenDialog.schliessen",
        text: "appZahlungsmethodeSetzenDialog.text",
        zahlungsmethodeSetzen: "appZahlungsmethodeSetzenDialog.zahlungsmethodeSetzen"
    },
    provisionHinweis: {
        preismodell: "provisionHinweis.preismodell",
        gemeinnuetzig: "provisionHinweis.gemeinnuetzig",
        gewerblich: "provisionHinweis.gewerblich",
        provisionTextTestzeitraum: "provisionHinweis.provisionTextTestzeitraum",
        provisionProTeilnahme: "provisionHinweis.provisionProTeilnahme",
        provisionGemeinnuetzig: "provisionHinweis.provisionGemeinnuetzig",
        provisionGewerblich: "provisionHinweis.provisionGewerblich",
        provisionMindestens: "provisionHinweis.provisionMindestens",
        nachweisGemeinnuetzigkeit: "provisionHinweis.nachweisGemeinnuetzigkeit",
        ustUndZusatzkosten: "provisionHinweis.ustUndZusatzkosten",
        minimalerAbrechnungsbetrag: "provisionHinweis.minimalerAbrechnungsbetrag"
    },
    navigationView: {
        row: "navigationView.row"
    },
    istMandantGueltigKontext: {
        keinMandant: "istMandantGueltigKontext.keinMandant",
        mandantUngueltig: "istMandantGueltigKontext.mandantUngueltig",
    },
    stripeSepaElement: {
        sepa: "stripeSepaElement.sepa",
        iban: "stripeSepaElement.iban",
        mandat: "stripeSepaElement.mandat",
        vollstaendigerName: "stripeSepaElement.vollstaendigerName",
        vollstaendigerNamePlaceholder: "stripeSepaElement.vollstaendigerNamePlaceholder",
    },
    paymentMethodToggle: {
        zahlungsmethodeKarte: "paymentMethodToggle.zahlungsmethodeKarte",
        zahlungsmethodeGiropay: "paymentMethodToggle.zahlungsmethodeGiropay",
        zahlungsmethodeSepa: "paymentMethodToggle.zahlungsmethodeSepa",
        zahlungsmethodeAufRechnung: "paymentMethodToggle.zahlungsmethodeAufRechnung",
        zahlungsmethodePayPal: "paymentMethodToggle.zahlungsmethodePayPal"
    },
    portalSpracheSelect: {
        de: "portalSpracheSelect.de",
        en: "portalSpracheSelect.en",
        sprache: "portalSpracheSelect.sprache"
    },
    filterMenu: {
        anwenden: "filterMenu.anwenden",
        zuruecksetzen: "filterMenu.zuruecksetzen",
    },
    legeBilderAnDialog: {
        dialogText: "legeBilderAnDialog.dialogText",
        dialogCaption: "legeBilderAnDialog.dialogCaption",
        bezeichnung: "legeBilderAnDialog.bezeichnung",
        anlegen: "legeBilderAnDialog.anlegen",
        abbrechen: "legeBilderAnDialog.abbrechen",
        titelbild: "legeBilderAnDialog.titelbild",
        quelle: "legeBilderAnDialog.quelle",
        loeschenTooltip: "legeBilderAnDialog.loeschenTooltip",
    },
    loescheBilderDialog: {
        dialogCaption: "loescheBilderDialog.dialogCaption",
        dialogText: "loescheBilderDialog.dialogText",
    },
    legeDateiAnDialog: {
        dialogText: "legeDateiAnDialog.dialogText",
        dialogCaption: "legeDateiAnDialog.dialogCaption",
        bezeichnung: "legeDateiAnDialog.bezeichnung",
        perEMailVersenden: "legeDateiAnDialog.perEMailVersenden",
        datei: "legeDateiAnDialog.datei",
        anlegen: "legeDateiAnDialog.anlegen",
        abbrechen: "legeDateiAnDialog.abbrechen",
        dateiTooltip: "legeDateiAnDialog.dateiTooltip"
    },
    loescheDateienDialog: {
        dialogCaption: "loescheDateienDialog.dialogCaption",
        dialogText: "loescheDateienDialog.dialogText",
    },
    kontoChip: {
        konto: "kontoChip.konto",
        eingeladen: "kontoChip.eingeladen"
    },
    ermittlePreisBezeichnung: {
        warteliste: "ermittlePreisBezeichnung.warteliste",
        ausverkauft: "ermittlePreisBezeichnung.ausverkauft",
        ausgebucht: "ermittlePreisBezeichnung.ausgebucht",
        kostenlos: "ermittlePreisBezeichnung.kostenlos",
    },
    zeitraumInput: {
        beginn: "zeitraumInput.beginn",
        ende: "zeitraumInput.ende",
    },
    geschlechtSelect: {
        maennlich: "geschlechtSelect.maennlich",
        weiblich: "geschlechtSelect.weiblich",
        divers: "geschlechtSelect.divers",
        keineAngabe: "geschlechtSelect.keineAngabe",
    },
    schnellvorschauView: {
        vorschau: "schnellvorschauView.vorschau",
        nichtAktuell: "schnellvorschauView.nichtAktuell",
        speichernZumAktualisieren: "schnellvorschauView.speichernZumAktualisieren",
    },
    cookieBannerDialog: {
        titel: "cookieBannerDialog.titel",
        text: "cookieBannerDialog.text",
        bestaetigen: "cookieBannerDialog.bestaetigen",
        ablehnen: "cookieBannerDialog.ablehnen",
        einstellungen: "cookieBannerDialog.einstellungen",
        speichern: "cookieBannerDialog.speichern",
        zustimmung: "cookieBannerDialog.zustimmung",
        details: "cookieBannerDialog.details",
        cookieKategorien: {
            statistik: "cookieBannerDialog.cookieKategorien.statistik",
        },
        anbieter: {
            clarity: "cookieBannerDialog.anbieter.clarity",
        },
        cookies: {
            clck: {
                bezeichnung: "cookieBannerDialog.cookies.clck.bezeichnung",
                beschreibung: "cookieBannerDialog.cookies.clck.beschreibung",
            },
            clsk: {
                bezeichnung: "cookieBannerDialog.cookies.clsk.bezeichnung",
                beschreibung: "cookieBannerDialog.cookies.clsk.beschreibung",
            },
            anonchk: {
                bezeichnung: "cookieBannerDialog.cookies.anonchk.bezeichnung",
                beschreibung: "cookieBannerDialog.cookies.anonchk.beschreibung",
            },
            clid: {
                bezeichnung: "cookieBannerDialog.cookies.clid.bezeichnung",
                beschreibung: "cookieBannerDialog.cookies.clid.beschreibung",
            },
            mr: {
                bezeichnung: "cookieBannerDialog.cookies.mr.bezeichnung",
                beschreibung: "cookieBannerDialog.cookies.mr.beschreibung",
            },
            muid: {
                bezeichnung: "cookieBannerDialog.cookies.muid.bezeichnung",
                beschreibung: "cookieBannerDialog.cookies.muid.beschreibung",
            },
        },
        speicherdauer: {
            zehnMinuten: "cookieBannerDialog.speicherdauer.zehnMinuten",
            eineWoche: "cookieBannerDialog.speicherdauer.eineWoche",
            einJahr: "cookieBannerDialog.speicherdauer.einJahr",
        }
    },
    anbieterDetails: {
        maximaleSpeicherdauer: "anbieterDetails.maximaleSpeicherdauer",
    },
    sortableTransferList: {
        selectedText: "sortableTransferList.selectedText",
        searchInputPlaceholder: "sortableTransferList.searchInputPlaceholder",
    },
    richTextInput: {
        bereinigt: "richTextInput.bereinigt"
    }
};

export const steuerartTranslationKeyMap = {
    [Steuerarten.netto]: translationKeys.steuerart.netto,
    [Steuerarten.brutto]: translationKeys.steuerart.brutto,
    [Steuerarten.umsatzsteuerbefreit]: translationKeys.steuerart.umsatzsteuerbefreit,
};
